import angular from 'angular';
import config from './config';
import browserConfig from './browser.config';
import routing from './routes';
import run from './run';
import uirouter from 'angular-ui-router';
import '../less/rulemailer.less';

import 'angular-cookies';
import 'angular-translate';
import 'angular-breadcrumb';
import 'angular-sanitize';
import 'angular-translate-loader-static-files';
import 'angular-filter';
import 'ui-select';
import 'sweetalert';
import 'restangular';
import 'angular-xeditable';
import 'angular-bootstrap-switch';
import 'angular-md5';
import 'angular-file-upload';
import 'angular-spectrum-colorpicker';
import 'angular-bootstrap-npm';
import 'angular-animate'

import mainModule from './modules/main/main.index';
import introModule from './modules/intro/intro.index';
import dashboardModule from './modules/dashboard/dashboard.index';
import tagModule from './modules/tag/tag.index';
import loginModule from './modules/login/login.index';
import signUp from './modules/sign-up/sign-up.index';
import automationModule from './modules/automation/automation.index';
import eventModule from './modules/event/event.index';
import settingsModule from './modules/setting/setting.index';
import accountModule from './modules/account/account.index';
import userModule from './modules/user/user.index';
import segmentModule from './modules/segment/segment.index';
import customizationModule from './modules/customize/customization.index';
import campaignModule from './modules/campaign/campaign.index';
import statisticModule from './modules/statistic/statistics.index';
import imageBankModule from './modules/imagebank/imagebank.index';
import subscriberModule from './modules/subscriber/subscriber.index';
import subscriberFormModule from './modules/subscriberForm/subscriberForm.index';
import facebookApp from './modules/facebook/facebook.index';
import templateModule from './modules/template/template.index';
import mailEditorModule from './modules/maileditor/maileditor.index';
import smsEditorModule from './modules/smseditor/smseditor.index';
import notificationModule from './modules/notification/notification.index';
import atomicDesignModule from "./modules/atomic-design/atomic-design.index";
import browserModule from './modules/browser/browser.index';

/*@ngInject*/
angular.module('RuleApp', [
    uirouter,
    'ngCookies',
    'ngAnimate',
    'pascalprecht.translate',
    'ncy-angular-breadcrumb',
    'ngSanitize',
    'angular.filter',
    'ui.select',
    'ui.bootstrap',
    'angular-md5',
    'restangular',
    'xeditable',
    'frapontillo.bootstrap-switch',
    'angularFileUpload',
    'angularSpectrumColorpicker',
    mainModule,
    introModule,
    dashboardModule,
    tagModule,
    loginModule,
    signUp,
    automationModule,
    eventModule,
    settingsModule,
    accountModule,
    userModule,
    segmentModule,
    customizationModule,
    campaignModule,
    statisticModule,
    imageBankModule,
    subscriberModule,
    subscriberFormModule,
    facebookApp,
    templateModule,
    mailEditorModule,
    smsEditorModule,
    notificationModule,
    atomicDesignModule
])  .config(routing)
    .config(config)
    .run(run);

/*@ngInject*/
angular.module('InBrowserApp', [
    uirouter,
    'ngSanitize',
    'ui.bootstrap',
    'ngCookies',
    'restangular',
    'ui.select',
    'angularSpectrumColorpicker',
    'pascalprecht.translate',
    'angular.filter',
    browserModule
]).config(browserConfig);
